module.exports = __webpack_public_path__ + "img/icon61.c94df3b1.png";